import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import {DataGridPro, GridToolbar} from '@mui/x-data-grid-pro';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import EditIcon from '@mui/icons-material/Edit'; 

export default function CustomerLoadsList(props){
    //console.debug("RTS Break CustomerLoadsList");
    const history = useNavigate();

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    
    function handleClick(e, cellValues){
        history("/CustomerLoadsEdit", {state: { idGuid:cellValues.row.idGuid, 
                                        display:cellValues.row.reel!=null?cellValues.row.reel:'N/A',
                                        displayExt:cellValues.row.tracker!=null?cellValues.row.tracker:'N/A', 
                                        mode:1}});
    }


    const columns = [
        {
            field: '',
            description:"Edit Load", 
            flex:1,
            maxWidth:60,
            renderCell: (cellValues) => {
                return (
                    <Box sx={{display:'flex', alignItems:'center', justifyContent:'center', alignContent:'center', pt:.5}}>
                        <Link onClick={(event) => {handleClick(event, cellValues);}} sx={{textDecoration:'none', cursor:'pointer'}}>
                            <EditIcon />
                        </Link>
                    </Box>
                );
            },
            align:"center",
            sortable:false,
            filterable:false,
            hideable:false,
            disableColumnMenu:true
        },
        {
            field: 'productName', 
            headerName: "Product", 
            description:"Product Name", 
            flex:4,
        },
        {
            field: 'reel', 
            headerName: "Reel", 
            description:"Reel Serial Number", 
            flex:3,
        },
        {
            field: 'reelType', 
            headerName: "Reel Type", 
            description:"Reel Type", 
            flex:3,
        },
        {
            field: 'tracker', 
            headerName: "Tracker", 
            description:"Tracker ESN", 
            flex:3,
        },
        {
            field: 'shipDate', 
            headerName: "Ship Date", 
            description:"Load Ship Date", 
            flex:2,
            valueGetter: (value, row) => {
                if(value == null){
                    return null;
                }

                return (
                    new Date(value)
                );
            },
            type:"date",
            valueFormatter: (value) => {
                if(value == null){
                    return null;
                }
                
                const formatObj = new Intl.DateTimeFormat("en-US");
                return (
                    formatObj.format(new Date(value))
                );
            },

        },                           
        {
            field: 'status', 
            headerName: "Status", 
            description:"Load Status", 
            flex:3,
            renderCell: (cellValues) => {
                let retValue = 'Unknown';
                switch(cellValues.value){
                    case 1:
                        retValue = 'Active (1)';
                        break;
                    case 25:
                        retValue = 'Marked for Pickup (25)';
                        break;
                    case 50:
                        retValue = 'On Pickup Request (50)';
                        break;
                    case 75:
                        retValue = 'Submitted for Pickup (75)';
                        break;
                    case 100:
                        retValue = 'Returned (100)';
                        break;
                    default:
                        retValue = 'Unknown';
                        break;
                }

                return retValue;
            },
        },
    ];


    function getVisibilityModel(){
        if(smallForm){
            return {reelType:false, tracker:false, status:false}
        }
        else{
            return {status:false}
        }
    };


    function getDensity(){
        if(smallForm){
            return "comfortable";
        }
        else{
            return "standard";
        }
    };


    return (
        <Box sx={{width:'100%', height:'100%', minHeight:'400px'}}>
            <DataGridPro
                pagination={true}
                slots={{toolbar: GridToolbar}}
                slotProps={{
                    toolbar:{
                        showQuickFilter:true,
                    }
                }}
                rows={props.data} 
                columns={columns} 
                getRowId={row => row.idGuid}
                initialState={{
                    columns:{
                        columnVisibilityModel: getVisibilityModel()
                    },
                    pagination: { paginationModel: { pageSize: 50 } },
                    density: getDensity() 

                }}                
            />
        </Box>
    );
}